export default __webpack_public_path__ + "static/media/business_page.88cdca35.pdf";